module.exports = __webpack_public_path__ + "static/media/partner-legalfly.3235f542.png";